// import { Button, Col, Row } from "react-bootstrap";
// import { NoData } from "../common/NoData";
// import { useDispatch } from "react-redux";
// import { useTranslation } from "react-i18next";
// import { updateAoInsuranceData } from "../../features/product";
// import { useState } from "react";
// import { CompanyDetails } from "../CompanyDetails";

// export const AoCompanyCard = ({ data, buyNowHandler }) => {
//   const dispatch = useDispatch();
//   const { t, i18n } = useTranslation();
//   const currentLanguage = i18n.language;
//   const [show, setShow] = useState(false);

//   const handleShow = () => setShow(true);
//   return (
//     <div className="policy-formBox details-box">
//       <div className="header-container">
//         <div className="header-details">
//           <div className="logo-text">
//             <div className={data?.company_image ? "policy-logo" : "w-100"}>
//               {data?.company_image ? (
//                 <img
//                   src={data?.company_image ?? ""}
//                   alt={data?.company_name}
//                   className="img-fluid"
//                 ></img>
//               ) : (
//                 <h4>{data?.company_name} </h4>
//               )}
//             </div>
//             <div className="logo-text-content">
//               <h4>{data?.company_name}</h4>
//               <Button className="btn h-btn">
//                 {t("planName")} - {data?.plan_name}
//               </Button>
//             </div>
//           </div>
//           <div>
//             <div className="sidebar-btn">
//               <Button className="btn h-btn">
//                 {t("basePrice")} : {data?.base_price} {data?.premium_currency}
//               </Button>
//               <Button className="btn h-btn" onClick={handleShow}>
//                 {t("view_more")}
//               </Button>
//             </div>
//             <CompanyDetails
//               show={show}
//               companyData={data}
//               handleClose={() => setShow(false)}
//             />
//           </div>
//         </div>
//         <h5 className="graphic-text">
//           {data?.product_id === 15 && data?.sub_product_id === 20
//             ? `${t("graphical_area_label")} : ${
//                 currentLanguage === "ar"
//                   ? data?.area_of_coverage?.display_value_ar || "NA"
//                   : data?.area_of_coverage?.display_value_en || "NA"
//               }`
//             : ``}
//         </h5>
//       </div>
//       <div className="main-details">
//         <Row>
//           <Col md={8} sm={12}>
//             <div className="details-item mt-3">
//               <h5 className="title">{t("covers")}</h5>
//               <ul className="horizontal-list">
//                 {data?.covers && data?.covers.length ? (
//                   data.covers.map((cover_item, coverIndex) => (
//                     <li
//                       key={`cover_master_${coverIndex}`}
//                       className={cover_item?.isSelected ? "active" : ""}
//                       onClick={() =>
//                         dispatch(
//                           updateAoInsuranceData({
//                             object_id: data?.object_id,
//                             value: cover_item?.premium,
//                             customAction: cover_item?.isSelected
//                               ? "decrement"
//                               : "increment",
//                             cover_id: cover_item?.code,
//                           })
//                         )
//                       }
//                     >
//                       {
//                         cover_item?.description[0][
//                           currentLanguage === "ar" ? "ar" : "eng"
//                         ]
//                       }{" "}
//                       - {cover_item?.premium}
//                     </li>
//                   ))
//                 ) : (
//                   <li>
//                     <NoData msg={t("noCoverMsg")} />
//                   </li>
//                 )}
//               </ul>
//             </div>
//           </Col>
//         </Row>
//       </div>
//       {data?.product_id === 15 && data?.sub_product_id === 20 ? (
//         <div className="form-note">
//           <h4>{t("formNote.disclaimer")}</h4>
//           <p>{t("formNote.note")}</p>
//         </div>
//       ) : (
//         ""
//       )}
//       <div className="details-footer">
//         <div className="detailsfooter-item">
//           <h4 className="title">
//             <span className="totalPayment">{t("totalPayment")}:</span>{" "}
//             <span className="total-price">{data?.premium_value}</span>{" "}
//             <span className="totalPayment-currency">
//               {data?.premium_currency} ({t("vat_exclude")})
//             </span>
//           </h4>
//           <Button className="btn h-btn" onClick={() => buyNowHandler(data)}>
//             {t("buyNow")}
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// };


import { Button, Col, Row } from "react-bootstrap";
import { NoData } from "../common/NoData";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { updateAoInsuranceData } from "../../features/product";
import { useState } from "react";
import { CompanyDetails } from "../CompanyDetails";
import "../../components/InsuranceCard.css";
import { ReactComponent as OmrSymbol } from "../../assets/SVG/omr_symbol.svg";


export const AoCompanyCard = ({ data, buyNowHandler }) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [show, setShow] = useState(false);
  const [showAllCovers, setShowAllCovers] = useState(false);
  const isTravel = data?.product_id === 15 && data?.sub_product_id === 20;
  const handleShow = () => setShow(true);

  return (
    <div className="card insurance-card h-100 shadow-sm">
      {/* Header Section */}
     <div className="card-header-custom">
        <a className="details-link" onClick={handleShow}>
          ⓘ {t("view_details")}
        </a>
        <div className="flex-fill">
          <div className="insurance-row just">
            <div className="insurance-logo mt-6">
              <img
                src={data?.company_image}
                alt={data?.company_name}
              />
            </div>
            <div className="insurance-content mt-2">
              <h4 className="company-title">{t(data.company_name.toLowerCase()
                    .trim()
                    .replace(/\s+/g, "_")        // replace spaces with _
                    .replace(/[^\w_]/g, ""))}</h4>

              <div className="badge-row gap-2">

                <div className="badge-column">
                   <span className="badge-grey">{t('instantInsurance')}</span>
                  <span className="badge-grey">{t('branches')}: 2</span>


                </div>

                <div className="badge-column">
                  <span className="badge-grey">{t('endorsement24to48')}</span>
                    {/* {!isTravel && (
                    <span className="badge-dark-yellow">Photos Not Required</span> */}
                  {/* )}    */}
                  <span className="badge-dark-yellow">{t("planName")} - {data?.plan_name}</span>

                </div>
              </div>
            </div>
          </div>
        </div>


        {/* Area/Vehicle Value */}
        {/* {data?.product_id === 15 && data?.sub_product_id === 20 ? (
          <div className="badge-light-custom w-100 text-center">
            {t("graphical_area_label")}: {currentLanguage === "ar"
              ? data?.area_of_coverage?.display_value_ar || "NA"
              : data?.area_of_coverage?.display_value_en || "NA"}
          </div>
        ) : (
          <div className="badge-light-custom w-100 text-center">
            {t("vehicle-value")}: {data?.extracted_data?.valuations ||
              data?.extracted_data?.vehicle_valuation ||
              "NA"}
          </div>
        )} */}
      </div>

      <CompanyDetails
        show={show}
        companyData={data}
        handleClose={() => setShow(false)}
      />

      {/* Covers Section (Acts as both included and optional) */}
      <div className="card-body">
        <h6 className="section-title">{t("covers")}</h6>
        <Row className="g-1">
          {data?.covers && data?.covers?.length ? (
            <>
              {(showAllCovers ? data?.covers : data?.covers?.slice(0, 4)).map((cover_item, coverIndex) => (
                
                <Col xs={6} key={`cover_master_${coverIndex}`}>
                  <div 
                    className="optional-item"
                    style={{ 
                      cursor: 'pointer',
                      backgroundColor: cover_item?.isSelected ? '#fff9e6' : 'transparent',
                      padding: '0.5rem',
                      borderRadius: '4px',
                      transition: 'background-color 0.2s'
                    }}
                    onClick={() =>
                      dispatch(
                        updateAoInsuranceData({
                          object_id: data?.object_id,
                          value: cover_item?.premium,
                          customAction: cover_item?.isSelected
                            ? "decrement"
                            : "increment",
                          cover_id: cover_item?.code,
                        })
                      )
                    }
                  >
                    <input
                      id={`ao_cover_cb_${coverIndex}`}
                      type="checkbox"
                      className="checkbox-custom"
                      checked={cover_item?.isSelected}
                      onChange={() => {}}
                      style={{ pointerEvents: 'none' }}
                    />
                    <label
                      htmlFor={`ao_cover_cb_${coverIndex}`}
                      style={{ cursor: 'pointer', margin: 0, pointerEvents: 'none' }}
                    >
                      {cover_item?.description[0][currentLanguage === "ar" ? "ar" : "eng"]}{" "}
                      - {cover_item?.premium} {data?.premium_currency}
                    </label>
                  </div>
                </Col>
              ))}
              {data.included_covers?.length > 4 && (
                <div className="p-0 m-0">
                  <button
                    className="btn btn-link p-0 m-0 text-decoration-none"
                    style={{ color: '#ff9800', fontSize: '0.9rem' }}
                    onClick={() => setShow(true)}
                  >
                    {showAllCovers ? "See less" :  t('see_more')}
                  </button>
                </div>
              )}
            </>
          ) : (
            <Col xs={12}>
              <NoData msg={t("noCoverMsg")} />
            </Col>
          )}
        </Row>
      </div>

      {/* Disclaimer for specific product */}
      {/* {data?.product_id === 15 && data?.sub_product_id === 20 && (
        <div className="card-body border-top pt-3">
          <h6 className="section-title">{t("formNote.disclaimer")}</h6>
          <p className="small text-muted mb-0">{t("formNote.note")}</p>
        </div>
      )} */}

         <div className="pricing-section mt-auto">
        <div className="price-row">

          {/* LEFT : Base Price */}
          <div className="base-price-section">
            <div className="base-price-label">{t("basePrice")}</div>

            <div className="base-price-inline">
              <span className="currency-icon">
                    {data?.premium_currency === "OMR" ? (
                      <OmrSymbol width={24} height={24} />
                    ) : (
                      data?.premium_currency
                    )}
                  </span>
              <div>
                <span className="base-price-value">{data?.base_price}</span>
                <span className="tax-inline">+VAT Inc</span>
              </div>
            </div>
          </div>

          {/* RIGHT : Total + Button */}
          <div className="total-price-section">
            <div className="total-price-label">{t("totalPayment")}</div>

             <div className="total-price-value">
                  <span className="currency-icon">
                    {data?.premium_currency === "OMR" ? (
                      <OmrSymbol width={24} height={24} />
                    ) : (
                      data?.premium_currency
                    )}
                  </span>
                  {data?.premium_value}
                </div>

            <button
              className="btn-buy-now"
              onClick={() => buyNowHandler(data)}
            >
              {t("buyNow")}
            </button>
          </div>

        </div>

        {/* <div className="vat-note">
          ({t("vat_include")})
        </div> */}
      </div>
    </div>
  );
};
